import { SilangIcon } from "App/Assets";
import { capitalizeFirst } from "App/utils/helpers";
import React from "react";
import styled from "@emotion/styled";

function WrapperTabItem({
  name,
  code,
  handleClickTab,
  handleClickRemoveTab,
  active,
  hasClose = true,
  classes,
}) {
  const ClickListItem = styled.button`
    appearance: none;
    border: 0;
    background: transparent;
    font-size: 0.6rem;
    -webkit-appearance: none;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    ${"" /* color:#fff; */}
  `;

  return (
    <div
      className={`${classes.tabMenu_item} ${
        active === code ? classes.active : ""
      }`}>
      <div className={classes.tabMenu_item_menu_wrapper}>
        <ClickListItem
          className={classes.tabMenu_item_menu}
          onClick={() => handleClickTab(code)}>
          <span> {capitalizeFirst(name)}</span>
        </ClickListItem>
        {hasClose && (
          <div
            className={classes.tabMenu_item_icon}
            onClick={() => handleClickRemoveTab(code)}>
            <SilangIcon width='8px' height='8px' fill='white' />
          </div>
        )}
      </div>
    </div>
  );
}

export default WrapperTabItem;
